import { createContext, useCallback, useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import HttpService from '../services/HttpService'
import { Button, Modal } from './ui'

export const isEmpresaConfigured = (data) => {
  if (!data) return false
  return Boolean(
    String(data.rfc || '').trim() ||
    String(data.razonSocial || '').trim() ||
    String(data.aliasCertificado || '').trim() ||
    String(data.dv ?? '').trim() ||
    String(data.cifrado || '').trim()
  )
}

const ConfigAccessContext = createContext(null)

export function ConfigAccessProvider({ children }) {
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const [checking, setChecking] = useState(false)

  const goToConfig = useCallback(() => {
    setOpen(false)
    navigate('/configuracion')
  }, [navigate])

  const requestAccess = useCallback(() => {
    if (checking) return
    setChecking(true)
    HttpService.getAxiosClient()
      .get('/empresa')
      .then((res) => {
        if (isEmpresaConfigured(res.data)) setOpen(true)
        else goToConfig()
      })
      .catch(() => goToConfig())
      .finally(() => setChecking(false))
  }, [checking, goToConfig])

  return (
    <ConfigAccessContext.Provider value={{ requestAccess, checking }}>
      {children}
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        title="Configuración crítica"
        footer={
          <>
            <Button variant="secondary" onClick={() => setOpen(false)}>Cancelar</Button>
            <Button variant="danger" onClick={goToConfig}>Aceptar</Button>
          </>
        }
      >
        <p className="text-sm text-slate-600">
          Esta configuración es necesaria para operar CoDi. Una modificación incorrecta puede impedir que tu empresa pueda transaccionar.
        </p>
        <p className="text-sm font-medium text-amber-800">
          Solo continúa si necesitas actualizar RFC, razón social, certificado o claves de cifrado.
        </p>
      </Modal>
    </ConfigAccessContext.Provider>
  )
}

export function ConfigAccessButton({ children, className }) {
  const ctx = useContext(ConfigAccessContext)
  if (!ctx) {
    throw new Error('ConfigAccessButton debe usarse dentro de ConfigAccessProvider')
  }
  return (
    <button type="button" onClick={ctx.requestAccess} className={className} disabled={ctx.checking}>
      {ctx.checking ? 'Revisando…' : children}
    </button>
  )
}

export default function ConfigAccess({ children, className }) {
  return (
    <ConfigAccessProvider>
      <ConfigAccessButton className={className}>{children}</ConfigAccessButton>
    </ConfigAccessProvider>
  )
}
